import { Snackbar, Alert } from "@mui/material";
const vertical = "top";
const horizontal = "center";
export const SuccessPop = ({ modalSuccess, setModalSuccess, content }) => {
  return (
    <Snackbar
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      open={modalSuccess}
      autoHideDuration={3000}
      onClose={() => setModalSuccess(false)}
    >
      <Alert severity="success" sx={{ fontWeight: 600 }}>
        {content}
      </Alert>
    </Snackbar>
  );
};

export const FailurePop = ({ modalFail, setModalFail, content }) => {
  return (
    <Snackbar
      anchorOrigin={{ vertical, horizontal }}
      open={modalFail}
      autoHideDuration={3000}
      onClose={() => setModalFail(false)}
    >
      <Alert severity="error" sx={{ fontWeight: 600 }}>
        {content}
      </Alert>
    </Snackbar>
  );
};
